import React from 'react';

import { Component, LoaderContainer, LoaderSpinner } from './Component.styles';


const Loader = () => {
  return (
  
      <Component >
        <LoaderContainer>
          <LoaderSpinner></LoaderSpinner>
        </LoaderContainer>
      </Component>

  );
};

export default Loader;
